import {
  Box,
  DropdownOptions,
  Flex,
  ModalProvider,
  Spinner,
  TooltipPopup,
} from "dash-ui";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import NotFoundPage from "pages/flow/NotFoundPage/NotFoundPage";
import PropertyDetailsHeader from "pages/properties/PropertyDetailsPage/components/PropertyDetailsHeader/PropertyDetailsHeader";
import PropertyDetailsTabs from "pages/properties/PropertyDetailsPage/components/PropertyDetailsTabs/PropertyDetailsTabs";
import DeletePropertyModal from "pages/properties/PropertyDetailsPage/components/DeletePropertyModal/DeletePropertyModal";
import { useBrowserTabTitle } from "common/hooks/use-browser-tab-title/use-browser-tab-title";

import { useGetPropertyByIdQuery } from "gql/generated.graphql";
import CreateChangelogConfirmationModal from "containers/properties/components/CreateChangelogConfirmationModal/CreateChangelogConfirmationModal";

function PropertyDetailsPage() {
  const { id } = useParams();
  const { t } = useTranslation();

  const { data, loading, refetch } = useGetPropertyByIdQuery({
    variables: { propertyId: id },
  });
  const property = data?.getPropertyById;

  useBrowserTabTitle(
    `${property ? property?.name : "Properties"} ${t(
      "common:labels.dashSuffix"
    )}`
  );

  return (
    <ModalProvider>
      <Flex flexDirection="column" flex={1} w="100%">
        <DropdownOptions />
        <TooltipPopup />
        <Box w="100%" pos="relative">
          {loading ? (
            <Spinner size={32} fullContent />
          ) : property ? (
            <>
              <PropertyDetailsHeader property={property} refetch={refetch} />
              <PropertyDetailsTabs property={property} />
              <CreateChangelogConfirmationModal />
              <DeletePropertyModal />
            </>
          ) : (
            <Box h={100}>
              <NotFoundPage />
            </Box>
          )}
        </Box>
      </Flex>
    </ModalProvider>
  );
}

export default PropertyDetailsPage;
